import { OnInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { RouterFilterReference } from "../../common/filters-router/filters-router.component";
import { FiltersTypeEnum } from 'world-archery-lib';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class ComboComponent extends RouterFilterReference {
    constructor(chg) {
        super(FiltersTypeEnum.ComboBox);
        this.chg = chg;
        this.subscriptions = [];
        /**
         *
         * Property name that must be access option object to change value of combo. Defaul : 'name'
         * @type {string}
         * @memberof ComboComponent
         */
        this.option_name_property = "name";
        /**
         *
         * Options values getted by subject
         * @type {Array<any>}
         * @memberof ComboComponent
         */
        this.options = [];
        /**
         * Set an specific initial state for combo. IF false initial state would be first element of array
         *
         * @type {boolean}
         * @memberof ComboComponent
         */
        this.initial_state = false;
    }
    ngOnInit() {
        if (this.hide_callback_function) {
            const callBackSub = this.hide_callback_function.asObservable().pipe(tap(a => {
                this.hideElementsFunction = a;
                this.chg.detectChanges();
            })).subscribe();
            this.subscriptions.push(callBackSub);
        }
        const subject_listen_change_options = this.options_subject
            .asObservable()
            .subscribe(next => {
            if (next instanceof Array) {
                if (this.hideElementsFunction != undefined) {
                    next = next.filter(this.hideElementsFunction);
                }
                this.options = next;
                if (this.initial_state === false) {
                    if (this.allConfig.selectMultiple) {
                        this.options_selected_subject.next([next[0]]);
                    }
                    else {
                        this.options_selected_subject.next(next[0]);
                    }
                }
            }
            else {
                throw new Error("Select items must be array instance");
            }
        });
        const subject_out_listen_change = this.options_selected_subject
            .asObservable()
            .subscribe(next => {
            this.selected = next;
            this.changeData.emit(next);
        });
        this.subscriptions.push(subject_listen_change_options, subject_out_listen_change);
        this.combo.nativeElement.addEventListener('selectedData', (event) => this.onChange(event.detail));
        if (this.allConfig.renderFunc) {
            this.combo.nativeElement['renderFunc'] = this.allConfig.renderFunc;
        }
        if (this.allConfig.renderFuncSelected) {
            this.combo.nativeElement['renderFuncSelected'] = this.allConfig.renderFuncSelected;
        }
    }
    onChange(option) {
        this.options_selected_subject.next(option);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(value => value ? value.unsubscribe() : undefined);
    }
    /**
     * A function for decide if the data should be hide or not and render combo.
     *
     * @param {Array<any>} data
     * @returns
     * @memberof ComboComponent
     */
    filterOptionsData(data) {
        if (this.hideElementsFunction != undefined) {
            return data.filter(this.hideElementsFunction);
        }
        else {
            return data;
        }
    }
    /**
     * Method for clear the combo.
     *
     * @memberof ComboComponent
     */
    clearCombo() {
        this.options_selected_subject.next([]);
    }
}
ComboComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ComboComponent_Factory() { return new ComboComponent(i0.ɵɵinject(i0.ChangeDetectorRef)); }, token: ComboComponent, providedIn: "root" });
